import cuid from "cuid";

export const sessionId = cuid();
